export default __webpack_public_path__ + "static/media/securityBanner.84a80891.gif";